import { LoadingIcon } from "@root/assets/icons/loadingicon";
import React from "react";
import { useLocation } from "react-router-dom";
import { LoadingContainer, LoadingText } from "./styles";

const LoadingWithText: React.FC<LoadingWithTextProps> = ({
  defaultText = "Loading...",
}) => {
  const location = useLocation();
  // extract text from location.state if present, otherwise use defaultText
  const text = (location.state as { text?: string })?.text || defaultText;

  return (
    <LoadingContainer>
      {<LoadingIcon />}
      <LoadingText>{text}</LoadingText>
    </LoadingContainer>
  );
};

export default LoadingWithText;
